import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00031InstallationFinish } from './P00031/Installation/P00031InstallationFinish';
import { P00031InstallationReset } from './P00031/Installation/P00031InstallationReset';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00031TunableMiseEnOeuvreInit } from './P00031/Tunable/miseenoeuvre/P00031TunableMiseEnOeuvreInit';

export class P00031Data {
  tunableStandardCProgSuivant: number = 0;

  tunableStandardCSynchronisationProg: number = 0;

  tunableStandardITypeEclairage: number = 0;

  tunableStandardSCommandeEclairage: number = 0;

  tunableStandardSCommandeHorloge: number = 0;

  tunableStandardPHorlogeJour: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableStandardPHorlogeSemaine: string = '000000000000';

  tunableStandardPTypeHorloge: number = 0;

  tunableStandardPDureeRuptureAlimentation: number = 0;

  tunableCouleurCFonctionnementModeOn: number = 0;

  tunableCouleurCCouleurModeOn: number = 0;

  tunableCouleurCProgModeOn: number = 0;

  tunableCouleurCSequenceModeOn: number = 0;

  tunableCouleurCControleProgSuivant: number = 0;

  tunableCouleurCControleProgPrecedent: number = 0;

  tunableCouleurPTypeCalendrier: number = 0;

  tunableCouleurPCalendrierJour03: string = '00000000000000000000000000000000';

  tunableCouleurPCalendrierSemaine07: string =
    '0000000000000000000000000000000000000000000000000000000000000000';

  tunableCouleurPCalendrierSemaine817: string =
    '00000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableCouleurPCalendrierSemaine1827: string =
    '00000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableCouleurPSequenceProgrammee01: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableCouleurPSequenceProgrammee23: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableCouleurSComportementEclairage: number = 0;

  tunableBlancCFonctionnementModeOn: number = 0;

  tunableBlancCTemperatureModeOn: number = 0;

  tunableBlancCProgModeOn: number = 0;

  tunableBlancCControleProgSuivant: number = 0;

  tunableBlancCControleProgPrecedent: number = 0;

  tunableBlancPTypeCalendrier: number = 0;

  tunableBlancPCalendrierSemaine07: string =
    '0000000000000000000000000000000000000000000000000000000000000000';

  tunableBlancPCalendrierJour03: string = '00000000000000000000000000000000';

  tunableBlancPCalendrierSemaine817: string =
    '00000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableBlancPCalendrierSemaine1827: string =
    '00000000000000000000000000000000000000000000000000000000000000000000000000000000';

  tunableBlancSComportementEclairage: number = 0;

  tunableITypeProjecteur: number = 0;

  tunableIConfigurationProduit: number = 0;

  tunableIActivationProtectionSousTension: number = 0;

  tunableIActivationProtectionThermique: number = 0;

  tunableISourceVolet: number = 0;

  tunableSAlarme: number = 0;

  tunableSEtatSortie: number = 0;

  tunableSProtectionThermique: number = 0;

  tunableSProtectionSousTension: number = 0;

  tunableSEtatVolet: number = 0;

  tunableSDisponibiliteEtatVolet: number = 0;

  tunableSArretEclairageFonctionVolet: number = 0;

  tunableSMiseEnRouteFiltration: number = 0;

  tunableSEtatFusible: number = 0;

  tunableSArretEclairageFonctionExtinction: number = 0;

  tunableSArretEclairageFonctionExtinction24h: number = 0;

  tunableSEtatBouton: number = 0;

  tunableSTemperature: number = 0;

  tunableSTension: number = 0;

  tunableSTempsProjecteursAllumes: number = 0;

  tunableSTempsSousTension: number = 0;

  tunableSCompteurProtectionThermique: number = 0;

  tunableSCompteurProtectionSousTension: number = 0;

  tunableSCompteurBouton: number = 0;

  tunableSCompteurErreurST: number = 0;

  tunableSCompteAReboursFonctionMinuterie: number = 0;

  tunableSCompteAReboursFonctionExtinction24h: number = 0;

  tunableSCompteurResetUsine: number = 0;

  tunableCResetManuelProtectionThermique: number = 0;

  tunableCResetManuelProtectionSousTension: number = 0;

  tunableCControleMinuterie: number = 0;

  tunableCResetUsine: number = 0;

  tunableCConfirmationOTA: number = 0;

  tunableCMode: number = 0;

  tunablePDureeMinuterie: number = 0;

  tunablePHeureExtinction: number = 0;

  tunablePActivationFonctionExtinction: number = 0;

  tunablePActivationFonctionExtinction24h: number = 0;

  tunablePActivationFonctionVolet: number = 0;

  tunablePActivationFonctionRedemEclairage: number = 0;
}

export class P00031 extends IProduct {
  override deviceTableIndex: number = 5;

  override modelIdentifier?: string = 'P00031';

  override dataIdentifier?: string = 'P00031';

  override manufacturerName?: string = 'ACWA';

  data: P00031Data = new P00031Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00031/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00031/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00031/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00031;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00031?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00031.tuto.installation.help.title',
      helpSlides: [
        'P00031.tuto.installation.help.1',
        'P00031.tuto.installation.help.2',
        'P00031.tuto.installation.help.3',
        'P00031.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00031/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00031/installation-1_dark.png',
          },
          text: 'P00031.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00031/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00031/installation-2_dark.png',
          },
          text: 'P00031.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00031/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00031/installation-1_dark.png',
          },
          text: 'P00031.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00031/update-2.png',
            dark: '/assets/ecosystem/images/products/P00031/update-2_dark.png',
          },
          text: 'P00031.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P00031InstallationProjecteur, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P00031InstallationFinish,
        reset: P00031InstallationReset,
      },
      controlCards: [
        //{ component : P00031CardTunableControle, weight: 2 },
      ],

      statusCards: [
        //{ component : P00031CardTunableStatut, weight: 10 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.LIGHTING];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.ECLAIRAGE) {
      return {
        miseEnOeuvre: {
          pages: [
            //{ component : P00031TunableMiseEnOeuvreProgEclairage, condition: () => { return true; } },
            //{ component : P00031TunableMiseEnOeuvreAutomatismes, condition: () => { return true; } },
          ],
          init: P00031TunableMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          //component: P00031TunableControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00031TunableParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P00031TunableStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00031TunableHistoriqueSuivi,
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Tunable_Controle,
      propertyName: 'tunableCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).tunableIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
